import { PROGRESS_STEPS } from '../../types';
import styles from './ProgressContainer.module.css';

const ProgressContainer = ({ activeStep }) => {
  return (
    <div className={styles.progressContainer}>
      <div className={styles.progressSteps}>
        {PROGRESS_STEPS.map((label, idx) => (
          <div
            key={idx}
            className={`${styles.progressStep} ${
              idx === activeStep ? styles.progressStepActive : ''
            } ${idx < activeStep ? styles.progressStepCompleted : ''}`}
          >
            <div className={styles.progressStepNumber}>
              {idx < activeStep ? <i className="pi pi-check" /> : idx + 1}
            </div>
            <span className={styles.progressStepLabel}>{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressContainer;
